// src/components/Expenses.js
import React, { useState } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Paper, Button, TextField } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || '';

const Expenses = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const token = localStorage.getItem('token');

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!file) return;
        const formData = new FormData();
        formData.append('document', file);

        try {
            const response = await axios.post(`${API_URL}/api/expenses`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            });
            setMessage(response.data.message);
        } catch (error) {
            console.error('Błąd przesyłania dokumentu:', error);
            setMessage('Błąd przesyłania dokumentu');
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 4 }}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>Dodaj wydatek (faktura/paragon)</Typography>
                    <Box component="form" onSubmit={handleUpload} sx={{ mt: 2 }}>
                        <TextField
                            type="file"
                            fullWidth
                            onChange={handleFileChange}
                            inputProps={{ accept: 'image/*,application/pdf' }}
                        />
                        <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                            Prześlij dokument
                        </Button>
                    </Box>
                    {message && <Typography sx={{ mt: 2 }}>{message}</Typography>}
                </Paper>
            </Box>
        </Container>
    );
};

export default Expenses;